import { Avatar, Box, Button, Grid2, Modal, Tab, Tabs, Typography } from "@mui/material";
import PropTypes from 'prop-types';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import connectAddress from '../../assets/images/connectAddress.svg';
import starIcon from '../../assets/icons/starIcon.png';
import React, { useEffect, useRef, useState } from "react";
import altProfile from '../../assets/images/altProfile.png';
import config from '../../config/config.js';
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import routeMarker from '../../assets/images/routeMarker.svg';
import yellowRouteMarker from '../../assets/images/yellowRouteMarker.svg';
import greyRouteMarker from '../../assets/images/greyRouteMarker.svg';
import { useLocation } from "react-router-dom";
import pickupMarker from '../../assets/icons/PickupIcon.svg';
import dayjs from 'dayjs'; // or import moment from 'moment';

import dropMarker from '../../assets/icons/DropIcon.svg';
import { GoogleMap, Marker, Polyline, useJsApiLoader } from "@react-google-maps/api";
// import truck from '../../assets/icons/truck.svg'
import { useGoogleMapsLoader } from "../../utils/GoogleMapsLoader";


const LIBRARIES = ["maps", "drawing", "places", "geometry"];
var constants = require('../../constant');

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
}
  
CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};
  
function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
}

const ClockTowerDetails = () => {

    const [value, setValue] = useState(0);
    const location = useLocation();
    const marker = location.state?.marker;
    const [center, setCenter] = useState({lat: 28.644800, lng: 77.216721});
    
    useEffect(() => {
        if (marker?.trip_details?.pickup_latitude && marker?.trip_details?.pickup_longitude) {
            setCenter({
                lat: Number(marker.trip_details.pickup_latitude),
                lng: Number(marker.trip_details.pickup_longitude)
            });
        }
    }, [marker]);
    const serverUrl = config.serverUrl;

    const [polylineVisible, setPolylineVisible] = useState(true);

    const [bluePath, setBluePath] = useState([]);

    useEffect(() => {
        if (marker?.trip_details) {
            const pickupPoint = {
                lat: Number(marker.trip_details.pickup_latitude),
                lng: Number(marker.trip_details.pickup_longitude)
            }
            const dropPoint = {
                lat: Number(marker.trip_details.drop_latitude),
                lng: Number(marker.trip_details.drop_longitude)
            }
            
            let completedStops = [pickupPoint, dropPoint];
            setBluePath(completedStops);
        }
    }, [marker]);

    // const loaderOptions = {
    //     id: 'google-map-script',
    //     googleMapsApiKey: constants.API_KEY, // Replace with your actual API key
    //     libraries: LIBRARIES,
    // }
    const { isLoaded, loadError } = useGoogleMapsLoader();
    const [map, setMap] = useState(null)
    const containerStyle = {
        width: '100%',
        height: '460px',
    };
    
    const onLoad = React.useCallback((map) => {
        console.log('Map loaded successfully');
        setMap(map); // Store the map instance
    }, []);
    
    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, []);

    useEffect(() => {
        if (marker?.trip_details && map) {
    
            const bounds = new window.google.maps.LatLngBounds();
            if (marker?.trip_details?.pickup_latitude && marker?.trip_details?.pickup_longitude) {
                bounds.extend(new window.google.maps.LatLng(Number(marker?.trip_details?.pickup_latitude), Number(marker?.trip_details?.pickup_longitude)));
            }
            if (marker?.trip_details?.drop_latitude && marker?.trip_details?.drop_longitude) {
                bounds.extend(new window.google.maps.LatLng(Number(marker?.trip_details?.drop_latitude), Number(marker?.trip_details?.drop_longitude)));
            }
    
            map.fitBounds(bounds); // Ensure all stops are visible
    
            // Force polyline to update
            setPolylineVisible(false);
            setTimeout(() => {
                setPolylineVisible(true);
            }, 50);
        }
    }, [marker, map]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return(
        <div>
            <Grid2 className="mainBox" sx={{padding:'0px 12px 12px 12px'}}>
                <Grid2 container item spacing={6} sx={{alignItems:'center'}}>
                    <Grid2 item>
                        <Grid2 item className='detailsHead'>Booking ID</Grid2>
                        <Grid2 item className='detailsText'>{marker.trip_details.booking_id}</Grid2>
                    </Grid2>
                    <Grid2 item className='detailsHead'>
                        <img src="/truck.svg" height="80px" width="80px" alt="truck" />
                    </Grid2>
                    <Grid2 item>
                        <Grid2 item className='detailsHead'>Plate Number</Grid2>
                        <Grid2 item className='detailsText'>{marker.vehicle_info.truck_plate_no}</Grid2>
                    </Grid2>
                    <Grid2 item sx={{backgroundColor:'#F9F9F9', display:'flex', alignItems:'center', padding:'8px', borderRadius:'8px'}}>
                        <Typography sx={{marginRight:'8px'}}>{marker.trip_details.pickup_location_name}</Typography>
                        <img src={connectAddress} alt="connect address" height="70%" width="70%" />
                        <Typography sx={{marginLeft:'8px'}}>{marker.trip_details.drop_location_name}</Typography>
                    </Grid2>

                    <Grid2 item sx={{marginTop:'24px', marginLeft:'auto', padding:'8px 16px'}}>
                        <Button
                            style={{
                                textTransform: 'none', pointerEvents: 'none', borderRadius: '6px', minWidth: '60px', padding:'16px',
                                border:'none', boxShadow: 'none', fontFamily: 'Poppins', height:'24px', border:'1px solid #36C68F'
                            }}
                        >
                            <FiberManualRecordIcon style={{ fontSize: '12px', color:'#36C68F' }}/>
                            <Typography sx={{color:'#36C68F'}}>Online</Typography>
                        </Button>
                    </Grid2>
                </Grid2>

                <hr/>

                <Box sx={{ width: '100%' }}>
                    <Box sx={{borderColor: 'divider' }}>
                        <Tabs 
                            value={value} 
                            onChange={handleChange} 
                            aria-label="basic tabs example"
                            TabIndicatorProps={{ 
                                style: { 
                                    display: 'none' // Hide the indicator completely
                                    // Or you can customize it with other properties:
                                    // backgroundColor: '#0065ff',
                                    // height: 3,
                                }
                            }}
                            sx={{
                                '& .MuiTabs-indicator': {
                                    display: 'none', // This is a secondary way to hide it
                                },
                            }}
                        >
                            <Tab 
                                label="Booking Details" 
                                {...a11yProps(0)} 
                                sx={{
                                    textTransform: 'none', 
                                    border:'1px solid #D1D5DB', 
                                    marginRight:'12px', 
                                    borderRadius:'10px', 
                                    '&.Mui-selected': { 
                                        color: 'white', 
                                        backgroundColor:'#0065ff', 
                                    },
                                }} 
                            />
                            <Tab 
                                label="Driver & Helper Info" 
                                {...a11yProps(1)} 
                                sx={{
                                    textTransform: 'none', 
                                    border:'1px solid #D1D5DB', 
                                    marginRight:'12px', 
                                    borderRadius:'10px', 
                                    '&.Mui-selected': { 
                                        color: 'white', 
                                        backgroundColor:'#0065ff',
                                    },
                                }} 
                            />
                        </Tabs>
                    </Box>

                </Box>
            </Grid2>

            <Grid2 container item sx={{display:'flex'}}>
                <Grid2 item size={4.5} sx={{marginTop:'1%',overflowY: 'auto',paddingRight: '12px',maxHeight: '64vh'}}>

                    <CustomTabPanel value={value} index={0}>
                        <Grid2 className="mainBox">
                            <Typography sx={{color:'#2A313C', fontSize:'20px', fontWeight:'600'}}>Trip Details</Typography>

                            <Grid2 sx={{marginTop:'2%', backgroundColor:'#F9F9F9', borderRadius:'10px'}}>
                                <Grid2 item container sx={{padding:'2%', marginTop:'2%', alignItems:'center'}}>
                                    <Grid2 item size={1}>
                                        <img src={pickupMarker} alt="pickup marker" width="20px" height="20px" />
                                    </Grid2>
                                    <Grid2 item size={11}>
                                        <Typography sx={{color:'#83888E', fontSize:'12px'}}>Starting Point</Typography>
                                        <Typography sx={{fontSize:'14px'}}>{marker.trip_details?.pickup_address}</Typography>
                                    </Grid2>
                                </Grid2>
                                <hr style={{border: 'none', borderTop: '2px dotted #D1D5DB', marginLeft:'36px'}} />

                                <Grid2 item container sx={{padding:'2%', alignItems:'center'}}>
                                    <Grid2 item size={1}>
                                        <img src={dropMarker} alt="drop marker" width="20px" height="20px" />
                                    </Grid2>
                                    <Grid2 item size={11}>
                                        <Typography sx={{color:'#83888E', fontSize:'12px'}}>End Point</Typography>
                                        <Typography sx={{fontSize:'14px'}}>{marker.trip_details?.drop_address}</Typography>
                                    </Grid2>
                                </Grid2>
                            </Grid2>

                            <Grid2 sx={{marginTop:'5%'}}>
                                <Typography sx={{color:'#83888E', fontSize:'14px'}}>Booking ID</Typography>
                                <Typography sx={{fontSize:'16px', marginTop:'1%'}}>{marker.trip_details.booking_id}</Typography>
                            </Grid2>
                            <hr/>
                            <Grid2 sx={{marginTop:'5%'}}>
                                <Typography sx={{color:'#83888E', fontSize:'14px'}}>Client</Typography>
                                <Typography sx={{fontSize:'16px', marginTop:'1%'}}>{marker.trip_details.tms_client_name}</Typography>
                            </Grid2>
                            <hr/>
                            <Grid2 sx={{marginTop:'5%'}}>
                                <Typography sx={{color:'#83888E', fontSize:'14px'}}>Type of Movement</Typography>
                                <Typography sx={{fontSize:'16px', marginTop:'1%'}}>{marker.trip_details.container_movement_type}</Typography>
                            </Grid2>
                            <hr/>
                            <Grid2 sx={{marginTop:'5%'}}>
                                <Typography sx={{color:'#83888E', fontSize:'14px'}}>Container Type</Typography>
                                <Typography sx={{fontSize:'16px', marginTop:'1%'}}>{marker.trip_details.container_type} km</Typography>
                            </Grid2>
                            <hr/>
                            <Grid2 sx={{marginTop:'5%'}}>
                                <Typography sx={{color:'#83888E', fontSize:'14px'}}>Container Size</Typography>
                                <Typography sx={{fontSize:'16px', marginTop:'1%'}}>{marker.trip_details.container_size} km</Typography>
                            </Grid2>
                            <hr/>
                            <Grid2 sx={{marginTop:'5%'}}>
                                <Typography sx={{color:'#83888E', fontSize:'14px'}}>Number of Containers</Typography>
                                <Typography sx={{fontSize:'16px', marginTop:'1%'}}>{marker.trip_details.container_details.length}</Typography>
                            </Grid2>
                            <hr/>
                            <Grid2 sx={{marginTop:'5%'}}>
                                <Typography sx={{color:'#83888E', fontSize:'14px'}}>Start Time</Typography>
                                <Typography sx={{fontSize:'16px', marginTop:'1%'}}>{dayjs(marker.trip_details.pickup_time).format('DD-MM-YY HH:mm:ss')}</Typography>
                            </Grid2>
                            <hr/>
                            <Grid2 sx={{marginTop:'5%'}}>
                                <Typography sx={{color:'#83888E', fontSize:'14px'}}>Distance</Typography>
                                <Typography sx={{fontSize:'16px', marginTop:'1%'}}>{marker.trip_details.distance} km</Typography>
                            </Grid2>
                            <hr/>
                            <Grid2 sx={{marginTop:'5%'}}>
                                <Typography sx={{color:'#83888E', fontSize:'14px'}}>Delivery Time</Typography>
                                <Typography sx={{fontSize:'16px', marginTop:'1%'}}>{dayjs(marker.trip_details.drop_time).format('DD-MM-YY HH:mm:ss')}</Typography>
                            </Grid2>
                        </Grid2>
                    </CustomTabPanel>

                    <CustomTabPanel value={value} index={1}>
                        <Grid2 className="mainBox">
                            <Typography sx={{color:'#2A313C', fontSize:'20px', fontWeight:'600'}}>Driver Details</Typography>

                            <Grid2 container sx={{ width: "auto", minWidth: "180px", marginTop: '5%' }} spacing={1} alignItems="center">
                                <Grid2 item>
                                    <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt="driverName" src={marker.driver_info.driver_image ? marker.driver_info.driver_image : altProfile} />
                                </Grid2>

                                <Grid2 item sx={{ textAlign: "left" }}>
                                    <Typography>{marker.driver_info.driver_name}</Typography>

                                    <Box sx={{ display: 'flex', alignItems: 'center', marginTop: '4px' }}>
                                    {[...Array(5)].map((_, index) => (
                                        <Box key={index} sx={{ marginRight: '4px' }}>
                                        {index < marker.driver_info.total_rating ? (
                                            <img src={starIcon} alt="star" height="12px" width="12px" />
                                        ) : (
                                            <></>
                                        )}
                                        </Box>
                                    ))}
                                    <Typography sx={{color:'#83888E', fontSize:'12px'}}>({marker.driver_info.no_of_rating} Reviews)</Typography>
                                    </Box>
                                </Grid2>
                            </Grid2>

                            <Grid2 sx={{marginTop:'5%'}}>
                                <Typography sx={{color:'#83888E', fontSize:'14px'}}>Driver ID</Typography>
                                <Typography sx={{fontSize:'16px', marginTop:'1%'}}>{marker.driver_info.driver_id}</Typography>
                            </Grid2>
                            <hr/>
                            <Grid2 sx={{marginTop:'5%'}}>
                                <Typography sx={{color:'#83888E', fontSize:'14px'}}>Driver Name</Typography>
                                <Typography sx={{fontSize:'16px', marginTop:'1%'}}>{marker.driver_info.driver_name}</Typography>
                            </Grid2>
                            <hr/>
                            <Grid2 sx={{marginTop:'5%'}}>
                                <Typography sx={{color:'#83888E', fontSize:'14px'}}>Mobile Number</Typography>
                                <Typography sx={{fontSize:'16px', marginTop:'1%'}}>{marker.driver_info.phone_number}</Typography>
                            </Grid2>
                            <hr/>
                            <Grid2 sx={{marginTop:'5%'}}>
                                <Typography sx={{color:'#83888E', fontSize:'14px'}}>Email</Typography>
                                <Typography sx={{fontSize:'16px', marginTop:'1%'}}>{marker.driver_info.email}</Typography>
                            </Grid2>
                        </Grid2>

                        <Grid2 className="mainBox" sx={{marginTop:'2%'}}>
                            <Typography sx={{color:'#2A313C', fontSize:'20px', fontWeight:'600'}}>Helper Details</Typography>

                            <Grid2 container sx={{ width: "auto", minWidth: "180px", marginTop: '5%' }} spacing={1} alignItems="center">
                                <Grid2 item>
                                    <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt="driverName" src={marker.helper_info.helper_image ? marker.helper_info.helper_image : altProfile} />
                                </Grid2>

                                <Grid2 item sx={{ textAlign: "left" }}>
                                    <Typography>{marker.helper_info.helper_name}</Typography>
                                </Grid2>
                            </Grid2>

                            <Grid2 sx={{marginTop:'5%'}}>
                                <Typography sx={{color:'#83888E', fontSize:'14px'}}>Helper ID</Typography>
                                <Typography sx={{fontSize:'16px', marginTop:'1%'}}>{marker.helper_info.helper_id}</Typography>
                            </Grid2>
                            <hr/>
                            <Grid2 sx={{marginTop:'5%'}}>
                                <Typography sx={{color:'#83888E', fontSize:'14px'}}>Helper Name</Typography>
                                <Typography sx={{fontSize:'16px', marginTop:'1%'}}>{marker.helper_info.helper_name}</Typography>
                            </Grid2>
                            <hr/>
                            <Grid2 sx={{marginTop:'5%'}}>
                                <Typography sx={{color:'#83888E', fontSize:'14px'}}>Mobile Number</Typography>
                                <Typography sx={{fontSize:'16px', marginTop:'1%'}}>{marker.helper_info.helper_phone}</Typography>
                            </Grid2>
                            <hr/>
                            <Grid2 sx={{marginTop:'5%'}}>
                                <Typography sx={{color:'#83888E', fontSize:'14px'}}>Email</Typography>
                                <Typography sx={{fontSize:'16px', marginTop:'1%'}}>{marker.helper_info.helper_email}</Typography>
                            </Grid2>
                        </Grid2>
                        
                    </CustomTabPanel>
                </Grid2>

                <Grid2 item size={7.5} className="mainBox" sx={{marginTop:'1%'}}>
                    {isLoaded ? (
                        <GoogleMap
                            mapContainerStyle={containerStyle}
                            center={center}
                            zoom={12}
                            onLoad={onLoad}
                            onUnmount={onUnmount}
                        >
                            {/* Render markers for each stop */}
                            {polylineVisible && marker?.trip_details && (
                                <>
                                    <Marker 
                                        key="pickup"
                                        position={{
                                            lat: Number(marker.trip_details.pickup_latitude),
                                            lng: Number(marker.trip_details.pickup_longitude)
                                        }}
                                        icon={{
                                            url: pickupMarker,
                                            scaledSize: new window.google.maps.Size(40, 40)
                                        }}
                                    />

                                    <Marker 
                                        key="drop"
                                        position={{
                                            lat: Number(marker.trip_details.drop_latitude),
                                            lng: Number(marker.trip_details.drop_longitude)
                                        }}
                                        icon={{
                                            url: dropMarker,
                                            scaledSize: new window.google.maps.Size(40, 40)
                                        }}
                                    />
                                </>
                            )}

                            {/* Blue Polyline for completed stops */}
                            {polylineVisible && bluePath.length > 1 && (
                                <Polyline
                                    path={bluePath}
                                    options={{
                                        strokeColor: "#0065FF",
                                        strokeOpacity: 1.0,
                                        strokeWeight: 4,
                                        zIndex: 1
                                    }}
                                />
                            )}
                        </GoogleMap>
                        
                    ): (<></>)}
                </Grid2>
            </Grid2>
        </div>
    )
}

export default ClockTowerDetails;